import React, {Fragment, useEffect, useReducer, useState} from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from '../ModalContentWrapper';
import useAutoForm from "../../Forms/useAutoForm";
import DemoModal from "root/DemoModal";
import {
    saveNewFamilyMember,
    updateFamilyMember,
    deleteFamilyMember,
    getFamilyMemberDetails,
    getFamilyMemberImageUrl
} from "root/DataFunctions/FamilyDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Components/SpinnerDiv";
import SingleFilePicker from "root/ReactHookForm/ControlWrappers/SingleFilePicker";
import {useForm} from "react-hook-form";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownUserRelationTypes from "root/ReactHookForm/ui/DropdownUserRelationTypes";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {IconPath} from "root/DataFunctions/Constants";
import VanillaModal from "../VanillaModal/VanillaModal";

const ModalAddFamilyMember = (props) =>
{
    const [ ,forceRender] = useReducer((s) => s+1, 0)
    const [ initialiseForm, renderForm, isFormValid, getFormData, setDisplayErrors, isInitialised] = useAutoForm( forceRender ) ;
    const [ buttonState, setButtonState ] = useState ('') ;
    const [data, setData] = useState({ isLoading: true, data: [] });
    const [newImageData, setNewImageData] = useState( null );
    const [imageDataAlias, setImageDataAlias] = useState( null );

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                post: {
                    firstname: '',
                    surname: '',
                    ar_type_id: undefined,
                    summary: ''
                }
            }
        });

    const isFetchRequired = props.mode === 'edit' || props.mode === 'view' || props.mode === 'delete' ;

    const titles = {
        view: 'View Family Member',
        edit: 'Edit Family Member',
        create: 'Create Family Member',
        delete: 'Delete Family Member'
    } ;

    const saveButtonText = {
        view: 'Close',
        edit: 'Save Changes',
        create: 'Save',
        delete: 'Delete'
    } ;

    const getDefaultData = () =>
    {
        return {
            firstname: '',
            surname: '',
        }
    }

    useEffect(() =>
    {
        if ( isFetchRequired )
        {
            getFamilyMemberDetails(props.child_id, props.family_member_id, (response) =>
            {
                let familyData = getDataFromResponse(response)[0] ;

                setValue ( 'familymember',
                    {
                        firstname : familyData.firstname,
                        surname : familyData.surname,
                        ar_type_id: { value: +(familyData.ar_type_id) },
                        document: familyData.document_id,
                        summary:familyData.summary
                    }) ;

                setData({ isLoading: false, data: familyData });
                setImageDataAlias(familyData.image_id);

            });
        }
        else
        {
            if ( props.mode === 'create')
            {
                setData({ isLoading: false, data: getDefaultData() });
            }
        }

    }, [props.family_member_id]);

    const onSaveComplete = () =>
    {
        props.onSaveCompleted ('saved');
        props.onClose() ;
    }

    const onClickCancel = () =>
    {
        props.onSaveCompleted ('cancel');
        props.onClose() ;
    }

    const doSaveNew = ( data ) =>
    {
        if ( !isFormValid())
        {
            setDisplayErrors( true ) ;
            setButtonState ( '' ) ;
        }
        else
        {
            data.familymember['image'] = newImageData;
            saveNewFamilyMember (props.child_id, props.family_id, data, onSaveComplete ) ;
        }
    }

    const doSave = (data) =>
    {
        if ( !isFormValid())
        {
            setDisplayErrors( true ) ;
            setButtonState ( '' ) ;
        }
        else
        {
            if (newImageData != null) data.familymember['image'] = newImageData;
            updateFamilyMember(props.child_id, props.family_member_id, data, onSaveComplete ) ;
        }
    }

    const doDelete = ( onComplete ) =>
    {
        deleteFamilyMember( props.child_id, props.family_member_id, onSaveComplete ) ;
    }

    const confirmShow = (title, message, action) =>
    {
        let cfrm = new VanillaModal ({
            title: title,
            content: message,
            buttons: VanillaModal.buttons.confirm
        })

        cfrm.show().once('dismiss', (modal, ev, button) => {
            if (button && button.value === true)
            {
                action() ;
            }
        });
    }

    const onSubmit = (data) => {
        disableButtons();

        switch (props.mode)
        {
            case 'create' :
                doSaveNew(data);
                break;
            case 'edit' :
                doSave(data);
                break;
            case 'delete' :
                    confirmShow ('Delete Family Member', 'Are you sure you want to delete this Family Member?', () =>
                    {
                        doDelete();
                    })
                break;
            case 'view' :
                props.onSaveCompleted ('cancel');
                props.onClose() ;
                break;
        }
    }

    const onClickSave = () =>
    {
        handleSubmit(onSubmit);
    }

    const disableButtons = () =>
    {
        setButtonState ('disabled');
    }

    const Title = ( props ) =>
    {
        return <h3>{titles[props.mode]}</h3>
    }

    const onImageChange = ( imageUrl ) =>
    {
        const reader = new window.FileReader();
        reader.readAsDataURL(imageUrl);

        reader.onloadend = () =>
        {
            setNewImageData ( reader.result ) ;
            setImageDataAlias ( reader.result ) ;
        }
    }

    const getSaveButtonText = ( mode ) =>
    {
        return saveButtonText[props.mode] ;
    }

    const getSaveButtonStyle= ( mode ) =>
    {
        switch ( mode )
        {
            case 'delete':
                return "btn btn-icon btn-danger btn-icon-right btn-small" ;
            default:
                return "btn btn-icon btn-primary btn-icon-right btn-small" ;
        }
    }

    const SaveButton = (props) =>
    {
        const clickHandler = buttonState === '' ? onClickSave : null;

        return (
            <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={buttonState} className={getSaveButtonStyle(props.mode)}>{getSaveButtonText(props.mode)}<i className="et-save" /></button>
        )
    }

    const handleUnsetDocument = () => {
        setValue('familymember.document', null);
        const dataHolder = { ...data.data, document_id: null };
        setData({ ...data, data: dataHolder });
    }

    const getDocumentUrl = (  ) =>
    {
        let url = '/getFile.php?enc_docid=' + data.data.document_id;
        return url;
    }

    const getDocumentIcon = (  ) =>
    {
        let icon = IconPath.ICON_DOCUMENT;
        return icon;
    }

    const handleRemoveImage = () => {
        setNewImageData("");
        setImageDataAlias(null);
    }

    const validateDropdown = (val) =>
    {
        if (val.value === undefined)
        {
            return "You must select a value";
        }
    }

    const renderHookForm = ( prop )  =>
    {
        const readOnlyMode = props.mode === 'view' || props.mode === 'delete' ? 'readonly' : '' ;
        const isReadOnly = props.mode === 'view' || props.mode === 'delete' ;
        const isViewOnly = props.mode === 'view';

        return (
            <Fragment>
                <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                    <div className="profile-img-container-wrap profile-img-container-wrap_child">
                        {!isReadOnly && 
                            <div className="post-all-image-wrap">
                                <div
                                    className={imageDataAlias === null ?
                                                "post-all-image"
                                                :
                                                "post-all-image post-all-image_show"
                                            }
                                >
                                    <DemoModal 
                                        image_id={data.data.image_id} 
                                        provider_id={1} 
                                        dimensions={150} 
                                        onImageChange={onImageChange}
                                        newImageData={newImageData}
                                        imageDataAlias={imageDataAlias}
                                        data={data}
                                    />
                                    <span onClick={handleRemoveImage} className="post-image-remove">
                                        <i className='icon-close'/>
                                    </span>
                                    <div className="post-all-image-overlay post-all-image-overlay_single"></div>
                                </div>
                            </div>
                        }

                        {isReadOnly && <img src={getFamilyMemberImageUrl(data.data.image_id, data.data.user_id, data.data.ar_type_id)} style={{width: '150px'}}/>}
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Firstname</label>
                                <input readOnly={readOnlyMode} className='form-control' name='familymember.firstname' id='firstname' {...register("familymember.firstname", { required: true})} />
                                { formErrors.post?.title && <ErrorDiv>Please enter a firstname</ErrorDiv> }
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div style={{marginBottom: '10px'}}>
                                <label>Surname</label>
                                <input readOnly={readOnlyMode} className='form-control' name='familymember.surname' id='surname' {...register("familymember.surname", { required: true})} />
                                { formErrors.post?.title && <ErrorDiv>Please enter a surname</ErrorDiv> }
                            </div>
                        </div>
                    </div>

                    <div style={{marginBottom: '10px'}}>
                        <label>Relation Type</label>
                        <DropdownUserRelationTypes readOnly={false} control={control}
                                                   mode={props.mode}
                                                   name='familymember.ar_type_id'
                                                   relationshipType={null}
                                                   rules={{required: true, validate: validateDropdown}}
                                                   placeholder='Please select a relation type'
                                                   isSearchable={true}
                                                   isClearable={true}/>
                        {formErrors.familymember?.ar_type_id &&
                            <ErrorDiv>{formErrors.familymember.ar_type_id.message}</ErrorDiv>}
                    </div>

                    <label>Summary</label>
                    <textarea readOnly={readOnlyMode} style={{marginBottom: '10px', minHeight: '10em'}} name='familymember.summary'
                              className='form-control' id='summary' {...register("familymember.summary")} />

                    {(props.mode !== 'create' && data.data.document_id !== null) &&
                        <div>
                            <label>Document (PDF)</label>
                            <div style={{position: 'relative', marginRight: '10px', marginBottom: '20px', marginTop: '20px'}}>
                                <a href={getDocumentUrl()} target="_blank" ><img alt="document" width="70" src={getDocumentIcon()}/></a>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-right">
                                            Remove Document
                                        </Tooltip>
                                    }
                                >
                                        <span onClick={() => handleUnsetDocument()} style={{position: 'absolute', top: '-15px', fontSize: '2.3rem', color: 'red', lineHeight: '8px', cursor: 'pointer'}}>
                                            x
                                        </span>
                                </OverlayTrigger>
                            </div>
                        </div>
                    }

                    {(!isReadOnly && data.data.document_id == null) &&
                        <div>
                            <label>Add a Document (PDF)</label>
                            <SingleFilePicker
                                name='familymember.document'
                                control={control}
                                options={{maxSizeMb: 20, accept: ['.doc', '.pdf', '.docx']}}
                                unsetDocument={handleUnsetDocument}/>
                        </div>
                    }

                    <div className="d-flex flex-row justify-content-end">
                        {!isViewOnly && <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i
                            className="et-arrow-bold-left"/></button>}
                        <SaveButton mode={props.mode} onClick={onClickSave}/>
                    </div>
                </form>
            </Fragment>
        )
    }


    return (
        <ModalContentWrapper className="modal-wrapper">
            <Title mode={props.mode} />
            <div style={{width: props.width}}>
                { data.isLoading && <SpinnerDiv /> }
                { !data.isLoading && renderHookForm ()}
            </div>

        </ModalContentWrapper>
    )
}

export default ModalAddFamilyMember;

ModalAddFamilyMember.defaultProps =
{
    width: '400px'
}

ModalAddFamilyMember.propTypes = {
    child_id: PropTypes.string.isRequired,
    family_id: PropTypes.string,
    width: PropTypes.string,
    mode: PropTypes.string.isRequired,
    onSaveCompleted: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
